/* ── Lägen och verktyg: sidans lägen till motorns ──
 * Sidan kallar sektionsläget 'box' (genvägen C), motorn 'clip'.
 * Allt här är "best-effort": fel sväljs så att visaren inte kraschar.
 */

const MODE_TO_ENGINE = { pick: 'pick', box: 'clip', measure: 'measure' };

/** Sidans läge ('pick' | 'box' | 'measure') till motorns ('pick' | 'clip' | 'measure'). */
export function engineMode(mode) {
  return MODE_TO_ENGINE[String(mode || 'pick')] || 'pick';
}

/** Sätter läge i motorn. Byte till Sektion eller Mät släpper markeringen (sköts av motorn). */
export function applyViewerMode(engine, mode) {
  try { engine?.setMode?.(engineMode(mode)); } catch { /* best-effort */ }
}

/** Dubbelklick/dubbeltryck i Sektion eller Mät, vid pekarhändelsens position. */
export function invokeModeAction(engine, mode, event) {
  if (engineMode(mode) === 'pick') return;
  try { Promise.resolve(engine?.toolAction?.(event?.clientX, event?.clientY)).catch(() => {}); } catch { /* best-effort */ }
}

/** Delete/Backspace: tar bort klipplan eller mått under pekaren (annars det senaste). */
export function deleteLastModeAction(engine, mode) {
  if (engineMode(mode) === 'pick') return;
  try { Promise.resolve(engine?.toolDelete?.()).catch(() => {}); } catch { /* best-effort */ }
}
